// Topbar Help dropdown (PRD §4.17): tutorials, onboarding, docs, WhatsApp
// support, raise-a-ticket, download invoices.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../lib/i18n';
import { cn } from '../../lib/cn';
import { HELP_ITEMS, type HelpItem } from '../../lib/nav';
import { HelpCircleIcon } from '../icons';

export default function HelpMenu() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  function activate(item: HelpItem) {
    setOpen(false);
    if (item.path) navigate(item.path);
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('topbar.help')}
        className="grid h-9 w-9 place-items-center rounded-full border border-line bg-slate-50 text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700"
      >
        <HelpCircleIcon size={18} />
      </button>

      {open && (
        <>
          <button
            type="button"
            aria-hidden
            tabIndex={-1}
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-40 cursor-default"
          />
          <div
            role="menu"
            className="absolute end-0 top-full z-50 mt-2 w-60 overflow-hidden rounded-card border border-line bg-white py-1 text-ink shadow-xl dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100"
          >
            <div className="px-3 py-2 text-[11px] font-bold uppercase tracking-wide text-ink-3 dark:text-slate-400">
              {t('help.title')}
            </div>
            {HELP_ITEMS.map((item) => {
              const Icon = item.icon;
              return item.href ? (
                <a
                  key={item.key}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  role="menuitem"
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-2.5 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800"
                >
                  <Icon size={16} className="text-slate-400 shrink-0" />
                  <span>{t(item.key)}</span>
                </a>
              ) : (
                <button
                  key={item.key}
                  type="button"
                  role="menuitem"
                  onClick={() => activate(item)}
                  className={cn(
                    'flex w-full items-center gap-2.5 px-3 py-2 text-start text-xs font-medium text-slate-700 hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800',
                  )}
                >
                  <Icon size={16} className="text-slate-400 shrink-0" />
                  <span>{t(item.key)}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
